(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
    .state('relatorioVistaAbertaCorregedoria', {
         url: "/membro/relatorioCorregedoria/relatorioVistaAberta",
         templateUrl: 'module/corregedoria/relatorioVistaAberta/relatorioVistaAberta.html',
         controller: 'RelatorioVistaAbertaCorregedoria',
         controllerAs: 'vm',
         params: {
           filtros: {},
           referer: ''
         }
     })
    .state('relatorioVistaAbertaPromotor', {
       url: "/membro/relatorioVistaAbertaPromotor/relatorioVistaAberta/:periodoInicial/:periodoFinal/:nomePromotor/:pessDk",
       templateUrl: 'module/corregedoria/relatorioVistaAbertaPromotor/relatorioVistaAbertaPromotor.html',
       controller: 'RelatorioVistaAbertaPromotor',
       controllerAs: 'vm',
       params: {
           periodoInicial: '',
           periodoFinal: '',
           nomePromotor: '',
           pessDk: '',
           filtros:{}
         }
    })
    .state('relatorioConcursoCorregedoria', {
         url: "/membro/relatorioCorregedoria/relatorioConcurso",
         templateUrl: 'module/corregedoria/relatorioConcurso/relatorioConcurso.html',
         controller: 'RelatorioConcursoCorregedoria',
         controllerAs: 'vm'
     });

  }

})();
